import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '../page';
import TablesComponent from './TableOne';

interface Props {}

export const Reports: FC<Props> = () => {
  const { t } = useTranslation();

  // interface RowData {
  //   id: number;
  //   name: string;
  //   regions: string[];
  //   workplace: string;
  //   position: string;
  //   specialization: string;
  //   category: string;
  //   orderNumber: string;
  //   issueDate: string;
  //   expiryDate: string;
  //   certificateNumber: string;
  // }

  // const rows: RowData[] = [
  //   {
  //     id: 1,
  //     name: 'Камолов Камол Камолиддинович',
  //     regions: ['Андижон', 'Фаргона', 'Наманган'],
  //     workplace: 'ШТЁ',
  //     position: 'тез ёрдам врачи',
  //     specialization: 'шошилинч тиббий ёрдам',
  //     category: 'иккинчи',
  //     orderNumber: 'VA 1111111',
  //     issueDate: '05/09/23',
  //     expiryDate: '05/09/28',
  //     certificateNumber: 'VA 1111111',
  //   },
  //   {
  //     id: 2,
  //     name: 'Фегатир Насрин Фегатиринович',
  //     regions: ['Фаргона'],
  //     workplace: 'Поликлиника',
  //     position: 'хирург',
  //     specialization: 'хирургия',
  //     category: 'биринчи',
  //     orderNumber: 'VA 5555555',
  //     issueDate: '17/11/23',
  //     expiryDate: '17/11/28',
  //     certificateNumber: 'VA 5555555',
  //   },
  //   {
  //     id: 3,
  //     name: 'Шеибали Насрин Камолович',
  //     regions: ['Наманган'],
  //     workplace: 'Травматология маркази',
  //     position: 'травматолог',
  //     specialization: 'травматология',
  //     category: 'олий',
  //     orderNumber: 'VA 7777777',
  //     issueDate: '24/04/24',
  //     expiryDate: '24/04/29',
  //     certificateNumber: 'VA 7777777',
  //   },
  // ];

  const [activeTab, setActiveTab] = React.useState<string>('one');
  const tabs = ['one', 'second', 'three', 'four', 'five', 'six'];

  return (
    <>
      <Page title={t('reports', 'Отчеты')}>
        {/* {t(
          'reports.preparing',
          'В настоящее время производится размещение отчетов в данный раздел'
        )} */}
        <TablesComponent />
        {/* <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Ф.И.Ш</TableCell>
                <TableCell>Худуд</TableCell>
                <TableCell>Иш жойи</TableCell>
                <TableCell>Лавозими</TableCell>
                <TableCell>Мутахассислиги</TableCell>
                <TableCell>Малака</TableCell>
                <TableCell>Буйрук рақами</TableCell>
                <TableCell>Берилган вакти</TableCell>
                <TableCell>Амал қилиш муддати</TableCell>
                <TableCell>Сертификат рақами</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>
                    {row.regions.map((region, index) => (
                      <div key={index}>{region}</div>
                    ))}
                  </TableCell>
                  <TableCell>{row.workplace}</TableCell>
                  <TableCell>{row.position}</TableCell>
                  <TableCell>{row.specialization}</TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell>{row.orderNumber}</TableCell>
                  <TableCell>{row.issueDate}</TableCell>
                  <TableCell>{row.expiryDate}</TableCell>
                  <TableCell>{row.certificateNumber}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer> */}
      </Page>
    </>
  );
};
